import { Link } from "react-router-dom";

const toneLabel = {
  ocean: "海南",
  launch: "发布",
  cloud: "合作",
  cosmos: "IP",
  exhibit: "落地",
  policy: "行业",
  city: "三亚",
  resort: "文旅",
};

export default function NewsCard({ news, featured = false }) {
  return (
    <Link
      to={`/news/${news.id}`}
      className={`news-card tone-${news.tone} ${featured ? "is-featured" : ""}`}
    >
      <div className="news-cover">
        <span>{toneLabel[news.tone] || "新闻"}</span>
      </div>
      <div className="news-body">
        <h3>{news.title}</h3>
        <p>{news.content}</p>
        <time>{news.date.replace(/-/g, ".")}</time>
      </div>
    </Link>
  );
}
